module.exports = __webpack_public_path__ + "static/img/Stephen.Dank.4aba094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Stephen.Dank.jpg
// module id = pZ/d
// module chunks = 0